// extracted by mini-css-extract-plugin
export default {"color-secondary":"Checkout_color-secondary__CUEWo","CartItems":"Checkout_CartItems__R1sMu","TotalAmount":"Checkout_TotalAmount__Pg-MP"};